<div class="layout-container" [class.sidebar-open]="isSidebarOpen()">
  <aside class="sidebar" [class.open]="isSidebarOpen()">
    <app-sidebar [isSidebarOpenInput]="isSidebarOpen()" (toggleSidebarOutput)="toggleSidebar()"></app-sidebar>
  </aside>

  <div class="layout-overlay" [class.visible]="isSidebarOpen()" (click)="toggleSidebar()"></div>

  <main class="parent-content">
    <div class="topbar">
      <app-topbar (menuToggle)="toggleSidebar()"></app-topbar>
    </div>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
